import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, environment } from '@core/envs';
import { IOpenSchedule, IPushNotification } from '@core/interface';
import { TypeMessage } from '@core/enums';

@Injectable({
  providedIn: 'root'
})
export class NewPushNotificationService {
  protected readonly http = inject(HttpClient);
  protected readonly url = `${environment.getRoute(API.transformation)}/notifications`;

  send(schedule: Partial<IOpenSchedule>, resourceType: string, fordProtect: boolean): void {
    const pushNotification = this.createPushNotification(schedule, resourceType, fordProtect);
    this.http.post<unknown>(this.url, pushNotification).subscribe();
  }

  protected createPushNotification(schedule: Partial<IOpenSchedule>, resourceType: string, fordProtect: boolean): IPushNotification {
    return {
      country: schedule.country as string,
      type: TypeMessage.PUSH,
      vin: schedule.vin as string,
      resourceType,
      scheduleHour: schedule.scheduleHour as number,
      source: 'agenda',
      division: 1,
      dealer: schedule.dealerId ?? schedule.dealer as number,
      advisor: schedule.advisorId ?? schedule.advisor as number,
      scheduleDate: schedule.scheduleDate as string,
      fordProtect
    }
  }
}
